<div class="document">
    <div class="header-section">
        <h1>Privacy Policy</h1>
        <p>Last updated: July 2022</p>
    </div>

    <p>1218 Team, Inc. ("us", "we", or "our") operates the https://www.my1218app.com and https://www.my1218apps.com websites and the My1218App family of mobile
        applications (the "Service").</p>
    <p>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you
        use our Service.</p>
    <p>1218 Team Inc. offers a SaaS platform marketed as myCAMPapp, myCLUBapp and myCONNECTEDapp (the "Services") operated by 1218 App Team, a company
        headquartered in the State of California in the United States ("we," "us," "our," and "1218 Team Inc.").</p>

    <p>The Services enable our Clients to, among other things, share content and send emails, mobile push notifications and text
        messages to their customers (Contacts).</p>

    <p>1218 Team Inc. takes data privacy seriously.</p>

    <p>We process information about our Clients’ Contacts as a data controller pursuant to our legitimate business interests. Our Services are intended for use
        by our Clients. As a result, for much of the Personal Information we collect and process about Contacts through the Services, we act as a processor on
        behalf of our Clients.</p>

    <p>1218 Team Inc. is not responsible for the privacy or security practices of our Clients. We use Clients and Contacts personal information as follows:</p>
    <ul>
        <li>To operate, maintain, and improve our sites, products, and services.</li>
        <li>To respond to comments and questions and provide customer service.</li>
        <li>To send information including confirmations, invoices, technical notices, updates, security alerts, and support and administrative messages.</li>
        <li>To provide and deliver products and services customers request.</li>
    </ul>

    <p>We will not share or sell personal information with any third party for marketing uses. We may share personal information as follows:</p>
    <ul>
        <li>We may share personal information with your consent.</li>
        <li>We may share personal information for legal, protection, and safety purposes.
            <ul>
                <li>We may share information to comply with laws.</li>
                <li>We may share information to respond to lawful requests and legal processes.</li>
                <li>We may share information to protect the rights and property of 1218 Team Inc., our agents, customers, and others. This includes enforcing
                    our agreements, policies, and terms of use.
                </li>
                <li>We may share information in an emergency. This includes protecting the safety of our employees and agents, our customers, or any person.</li>
            </ul>
        </li>
        <li>We may share information with those who need it to do work for us.</li>
        <li>We may also share aggregated and/or anonymized data with others for statistical reports.</li>
    </ul>

    <p>We will not use or share your information with anyone except as described in this Privacy Policy.</p>
    <p>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the
        collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy,
        terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>

    <p class="section-heading">Information Collection And Use</p>
    <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be
        used to contact or identify you. Personally identifiable information may include, but is not limited to, your email
        address, name, phone number, postal address, other information ("Personal Information").
        We collect this information for the purpose of providing the Service, identifying and communicating with you,
        responding to your requests/inquiries, servicing your purchase orders, and improving our services.</p>

    <p class="section-heading">Log Data</p>
    <p>We may also collect information that your browser sends whenever you visit our Service or when you access the Service
        by or through a mobile device ("Log Data").</p>
    <p>This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser
        version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and
        other statistics.</p>
    <p>When you access the Service by or through a mobile device, this Log Data may include information such as the type of
        mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating
        system, the type of mobile Internet browser you use and other statistics.</p>

    <p class="section-heading">Cookies</p>
    <p>Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to
        your browser from a web site and transferred to your device. We use cookies to collect information in order to
        improve our services for you.</p>
    <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on
        most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new
        cookie.</p>
    <p>If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave
        them turned on.</p>

    <p class="section-heading">Do Not Track Disclosure</p>
    <p>We support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that
        you do not want to be tracked.</p>
    <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>

    <p class="section-heading">Service Providers</p>
    <p>We may employ third-party companies and individuals to facilitate our Service, to provide the Service on our behalf,
        to perform Service-related services and/or to assist us in analyzing how our Service is used.</p>
    <p>These third parties have access to your Personal Information only to perform specific tasks on our behalf and are
        obligated not to disclose or use your information for any other purpose.</p>

    <p class="section-heading">Communications</p>
    <p>We may use Clients' Personal Information to contact Clients with newsletters, marketing or promotional materials and other
        information that may be of interest to you. You may opt out of receiving any, or all, of these communications from
        us by following the unsubscribe link or instructions provided in any email we send or by contacting us.</p>

    <p class="section-heading">Compliance With Laws</p>
    <p>We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such
        action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security
        or integrity of our Service.</p>

    <p class="section-heading">Security</p>
    <p>The security of your Personal Information is important to us, and we strive to implement and maintain reasonable,
        commercially acceptable security procedures and practices appropriate to the nature of the information we store, in
        order to protect it from unauthorized access, destruction, use, modification, or disclosure.</p>
    <p>However, please be aware that no method of transmission over the internet, or method of electronic storage is 100%
        secure and we are unable to guarantee the absolute security of the Personal Information we have collected from
        you.</p>

    <p class="section-heading">International Transfer</p>
    <p>Your information, including Personal Information, may be transferred to — and maintained on — computers located
        outside of your state, province, country or other governmental jurisdiction where the data protection laws may
        differ than those from your jurisdiction.</p>
    <p>If you are located outside United States and choose to provide information to us, please note that we transfer the
        information, including Personal Information, to United States and process it there.</p>
    <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that
        transfer.</p>

    <p class="section-heading">Links To Other Sites</p>
    <p>Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you
        will be directed to that third-party's site. We strongly advise you to review the Privacy Policy of every site you
        visit.</p>
    <p>We have no control over, and assume no responsibility for the content, privacy policies or practices of any
        third-party sites or services.</p>

    <p class="section-heading">Facial Recognition</p>
    <p>Facial Recognition for myCAMPapp uses Microsoft Azure Face API. By using the Service and adding a reference image,
        you consent to the use of facial recognition technology to identify photos on the Service in which you appear.
        You represent that the reference image photo added by you to the Service is you (or a family member for whom you
        are the legal guardian or have their consent) and that you are not impersonating or misrepresenting yourself as any
        other person or entity. Please refer to https://www.microsoft.com/en-us/trust-center/privacy for more details about privacy and compliance.</p>

    <p class="section-heading">Children's Privacy</p>
    <p>Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age
        of 13 ("Children").</p>
    <p>We do not knowingly collect personally identifiable information from children under 13. If you are a parent or
        guardian and you learn that your Children have provided us with Personal Information, please contact us. If we
        become aware that we have collected Personal Information from a children under age 13 without verification of
        parental consent, we take steps to remove that information from our servers.</p>

    <p class="section-heading">Changes To This Privacy Policy</p>
    <p>This Privacy Policy is effective as of February, 2020 and will remain in effect except with respect to any changes in
        its provisions in the future, which will be in effect immediately after being posted on this page.</p>
    <p>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy
        periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page
        will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified
        Privacy Policy.</p>
    <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have
        provided us, or by placing a prominent notice on our website.</p>

    <p class="section-heading">Contact Us</p>
    <p>If you have any questions about this Privacy Policy, please contact us.</p>
</div>
